import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TeklifDetay = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [teklif, setTeklif] = useState(null);
  const [musteri, setMusteri] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeklifDetay();
  }, [id]);

  const fetchTeklifDetay = async () => {
    try {
      const teklifRes = await axios.get(`${API}/teklifler/${id}`);
      setTeklif(teklifRes.data);

      // Fetch customer info
      const musteriRes = await axios.get(`${API}/musteriler`);
      const musteriData = musteriRes.data.find(m => m.id === teklifRes.data.musteri_id);
      setMusteri(musteriData);
    } catch (error) {
      console.error('Teklif detayları yüklenirken hata:', error);
      alert('Teklif bulunamadı');
      navigate('/teklifler');
    } finally {
      setLoading(false);
    }
  };

  const calculateSubtotal = () => {
    if (!teklif) return 0;
    return teklif.kalemler.reduce((sum, item) => sum + (item.miktar * item.birim_fiyat), 0);
  };

  const calculateKDV = () => {
    return calculateSubtotal() * (teklif?.kdv_orani || 20) / 100;
  };

  const calculateTotal = () => {
    return calculateSubtotal() + calculateKDV();
  };

  const printProforma = async () => {
    try {
      const response = await axios.get(`${API}/print/proforma/${id}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `proforma_${teklif.teklif_no}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Proforma oluşturulurken hata:', error);
      alert('Proforma oluşturulamadı');
    }
  };

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  if (!teklif) {
    return <div>Teklif bulunamadı</div>;
  }

  return (
    <div data-testid="proposal-detail-page" style={{ maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        padding: '16px 24px',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <div>
          <button 
            onClick={() => navigate('/teklifler')} 
            style={{
              background: 'none',
              border: 'none',
              color: '#3b82f6',
              cursor: 'pointer',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            ← Tekliflere Dön
          </button>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 700 }}>
            {teklif.teklif_no}
          </h1>
          <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '14px' }}>
            Teklif Detayı
          </p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button className="btn btn-primary" onClick={() => navigate(`/teklifler/duzenle/${id}`)}>
            ✏️ Düzenle
          </button>
          <button className="btn" onClick={printProforma}>
            🖨️ Proforma Yazdır
          </button>
        </div>
      </div>

      {/* Company & Customer Info */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
        {/* Company (Sender) */}
        <div className="card">
          <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, color: '#1e293b' }}>
            🏢 GÖNDEREN
          </h3>
          <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: 600, fontSize: '15px' }}>DOĞAN VİNÇ A.Ş.</p>
            <p style={{ margin: 0, color: '#64748b' }}>Adres: [Firma Adresi]</p>
            <p style={{ margin: 0, color: '#64748b' }}>Tel: [Telefon]</p>
            <p style={{ margin: 0, color: '#64748b' }}>Vergi Dairesi: [V.D.]</p>
          </div>
        </div>

        {/* Customer (Recipient) */}
        <div className="card">
          <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, color: '#1e293b' }}>
            👤 MÜŞTERİ
          </h3>
          <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: 600, fontSize: '15px' }}>
              {musteri?.ad || '-'}
            </p>
            <p style={{ margin: 0, color: '#64748b' }}>Adres: {musteri?.adres || '-'}</p>
            <p style={{ margin: 0, color: '#64748b' }}>Tel: {musteri?.telefon || '-'}</p>
            <p style={{ margin: 0, color: '#64748b' }}>İlgili: {musteri?.yetkili || '-'}</p>
          </div>
        </div>
      </div>

      {/* Invoice Details */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600 }}>
          📋 Teklif Bilgileri
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', fontSize: '14px' }}>
          <div>
            <span style={{ color: '#64748b' }}>Fatura No:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>{teklif.teklif_no}</p>
          </div>
          <div>
            <span style={{ color: '#64748b' }}>Tarih:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>
              {new Date(teklif.tarih).toLocaleDateString('tr-TR')}
            </p>
          </div>
          <div>
            <span style={{ color: '#64748b' }}>Geçerlilik:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>{teklif.gecerlilik} gün</p>
          </div>
        </div>
      </div>

      {/* Service Scope */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600 }}>
          🔧 HİZMET / TEKLİF KAPSAMI
        </h3>
        <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
          {teklif.kapsam || 'Vinç İmalatı ve Montajı'}
        </p>
      </div>

      {/* Items Table */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <table className="table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>No</th>
              <th>Açıklama</th>
              <th style={{ width: '100px', textAlign: 'center' }}>Adet</th>
              <th style={{ width: '150px', textAlign: 'right' }}>Birim Fiyat</th>
              <th style={{ width: '150px', textAlign: 'right' }}>Toplam</th>
            </tr>
          </thead>
          <tbody>
            {teklif.kalemler.map((kalem, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td>{kalem.aciklama}</td>
                <td style={{ textAlign: 'center' }}>{kalem.miktar}</td>
                <td style={{ textAlign: 'right' }}>
                  {kalem.birim_fiyat.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 600 }}>
                  {(kalem.miktar * kalem.birim_fiyat).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Financial Summary */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '24px' }}>
        <div style={{
          width: '400px',
          padding: '20px',
          background: '#f8fafc',
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', fontSize: '14px' }}>
            <span style={{ color: '#64748b' }}>Ara Toplam:</span>
            <span style={{ fontWeight: 600 }}>
              {calculateSubtotal().toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', fontSize: '14px' }}>
            <span style={{ color: '#64748b' }}>KDV (%{teklif.kdv_orani}):</span>
            <span style={{ fontWeight: 600 }}>
              {calculateKDV().toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}
            </span>
          </div>
          <div style={{
            borderTop: '2px solid #cbd5e1',
            paddingTop: '12px',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '16px'
          }}>
            <span style={{ fontWeight: 700 }}>GENEL TOPLAM:</span>
            <span style={{ fontWeight: 700, color: '#3b82f6' }}>
              {calculateTotal().toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}
            </span>
          </div>
        </div>
      </div>

      {/* Payment Terms */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
        <div className="card">
          <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: 600 }}>
            💳 Ödeme Koşulları
          </h3>
          <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
            <strong>Ödeme Şekli:</strong> {teklif.odeme_sekli || 'Banka Havalesi'}
          </p>
          <p style={{ margin: 0, fontSize: '14px' }}>
            <strong>Ödeme Tipi:</strong> {teklif.odeme_tipi || 'Peşin ödeme'}
          </p>
        </div>

        <div className="card">
          <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: 600 }}>
            🏦 Banka Bilgileri
          </h3>
          <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
            <strong>Banka:</strong> {teklif.banka_adi || '[Banka Adı]'}
          </p>
          <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
            <strong>IBAN:</strong> {teklif.iban || '[IBAN]'}
          </p>
          <p style={{ margin: 0, fontSize: '14px' }}>
            <strong>Para Birimi:</strong> {teklif.para_birimi}
          </p>
        </div>
      </div>

      {/* Delivery Terms */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: 600 }}>
          🚚 Teslimat Bilgileri
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', fontSize: '14px' }}>
          <div>
            <span style={{ color: '#64748b' }}>Teslim Süresi:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>
              {teklif.teslim_suresi || 'Hariçtir'}
            </p>
          </div>
          <div>
            <span style={{ color: '#64748b' }}>Nakliye:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>
              {teklif.nakliye || 'Hariçtir'}
            </p>
          </div>
          <div>
            <span style={{ color: '#64748b' }}>Mobil / Sepetli Vinç:</span>
            <p style={{ margin: '4px 0 0 0', fontWeight: 600 }}>
              {teklif.mobil_vinc || 'Hariçtir'}
            </p>
          </div>
        </div>
      </div>

      {/* Notes */}
      <div className="card" style={{
        background: '#fffbeb',
        border: '1px solid #fde68a'
      }}>
        <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: 600 }}>
          📝 Notlar
        </h3>
        <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6' }}>
          {teklif.notlar || 'Bu belge proforma fatura olup teklif amaçlı hazırlanmıştır.'}
        </p>
      </div>
    </div>
  );
};

export default TeklifDetay;
